export const TRANSFORM_IDS = [
    'lowercase',
    'uppercase',
    'capitalizeWords',
    'sentenceCase',
    'removeExtraSpaces',
    'removeDuplicateLines',
    'removeEmptyLines',
];

function getWords(text) {
    return text.trim() === '' ? [] : text.trim().split(/\s+/);
}

function countSentences(text) {
    return text.trim() === '' ? 0 : text.split(/[.!?]+/).filter((s) => s.trim() !== '').length;
}

function uniqueWordCount(text) {
    const words = text.toLowerCase().match(/[\wঀ-৿]+/g);
    return words ? new Set(words).size : 0;
}

function topWords(text, limit = 10) {
    const words = text.toLowerCase().match(/[\wঀ-৿]{2,}/g);
    if (!words) return [];
    const freq = {};
    for (const word of words) {
        freq[word] = (freq[word] || 0) + 1;
    }
    return Object.entries(freq)
        .sort((a, b) => b[1] - a[1])
        .slice(0, limit);
}

function sentenceCase(text) {
    return text
        .toLowerCase()
        .replace(/(^\s*[\wঀ-৿]|[.!?]\s+[\wঀ-৿])/g, (char) => char.toUpperCase());
}

function capitalizeWords(text) {
    return text
        .split(/(\s+)/)
        .map((part) => {
            if (/^\s+$/.test(part) || part.length === 0) return part;
            return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
        })
        .join('');
}

function removeExtraSpaces(text) {
    return text.replace(/[ \t]+/g, ' ').replace(/\n{3,}/g, '\n\n').trim();
}

function removeDuplicateLines(text) {
    const seen = new Set();
    return text.split('\n').filter((line) => {
        const key = line.trim();
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
    }).join('\n');
}

function removeEmptyLines(text) {
    return text.split('\n').filter((line) => line.trim() !== '').join('\n');
}

const TRANSFORM_FNS = {
    lowercase: (text) => text.toLowerCase(),
    uppercase: (text) => text.toUpperCase(),
    capitalizeWords,
    sentenceCase,
    removeExtraSpaces,
    removeDuplicateLines,
    removeEmptyLines,
};

export function analyzeText(text) {
    const words = getWords(text);
    return {
        words: words.length,
        charsWith: text.length,
        charsNo: text.replace(/\s/g, '').length,
        sentences: countSentences(text),
        unique: uniqueWordCount(text),
        topWords: topWords(text, 10),
    };
}

export function getReadingTimeMinutes(wordCount) {
    const mins = wordCount / 200;
    if (mins < 1) return { underOne: true, minutes: 0 };
    return { underOne: false, minutes: Math.ceil(mins) };
}

export function applyTextTransform(text, transformId) {
    const fn = TRANSFORM_FNS[transformId];
    return fn ? fn(text) : text;
}
